import "./WaitingRoomNotificationCard.css";

const WaitingRoomQueuePanel = ({
  isAdmitting = false,
  onAdmit,
  onClose,
  patients = [],
}) => {
  if (!patients.length) return null;

  return (
    <div className="cm-waiting-room-queue-panel">
      <div className="cm-waiting-room-queue-header">
        <h3>Waiting Room</h3>
        <button
          aria-label="Close waiting room panel"
          className="cm-waiting-room-queue-close"
          onClick={onClose}
          type="button">
          &times;
        </button>
      </div>

      <ul className="cm-waiting-room-queue-list">
        {patients.map((patient) => {
          const patientName =
            patient.patientName ||
            `${patient.firstname ?? ""} ${patient.lastname ?? ""}`.trim() ||
            "Patient";

          return (
            <li className="cm-waiting-room-queue-item" key={patient.patientId}>
              <div className="cm-waiting-room-queue-patient">
                <span className="cm-waiting-room-notification-avatar">
                  {patient.initials || "?"}
                </span>
                <div>
                  <p className="cm-waiting-room-notification-name">{patientName}</p>
                  <p className="cm-waiting-room-notification-status">
                    Joined the waiting room
                  </p>
                </div>
              </div>

              <button
                className="cm-waiting-room-notification-admit"
                disabled={isAdmitting}
                onClick={() => onAdmit(patient.patientId)}
                type="button">
                Admit
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default WaitingRoomQueuePanel;
